import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Card, Button } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import { useHistory } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from '../Shared/Header/Header';
import Footer from '../Shared/Footer/Footer';
import { useApp } from '../../contexts/AppContext';

const AllProjects = () => {
  const { isInitialLoad, setIsInitialLoad } = useApp();

  useEffect(() => {
    if (isInitialLoad) return;
    setIsInitialLoad(true);
  }, [isInitialLoad, setIsInitialLoad]);

  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);

  let history = useHistory();
  //fetch json data and setting it to a state
  useEffect(() => {
    fetch('/allProjectsData.json')
      .then((res) => res.json())
      .then((data) => {
        setProjects(data);
        setLoading(false);
        console.log(data);
      });
  }, []);

  return (
    <>
      <Header></Header>
      <Container fluid>
        <motion.h1
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 2 }}
          className='text-center fw-bold mb-4  mt-5'
        >
          More Top Projects
        </motion.h1>
        <motion.h4
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 2 }}
          className='text-center mb-5 text-secondary pb-5 '
        >
          See all of my unique and diverse projects
        </motion.h4>
        <Row xs={1} md={3} className='g-2 mb-5'>
          {loading ? (
            <Spinner animation='grow' className='mx-auto' />
          ) : (
            projects?.map((project) => (
              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 2 }}
                key={project?.id}
              >
                <Col className='h-100'>
                  <Card className='text-center h-100'>
                    <Card.Img
                      variant='top'
                      src={project?.imgHome}
                      style={{ height: '300px' }}
                    />
                    <Card.Body className='d-flex flex-column justify-content-between'>
                      <div className='mb-4'>
                        <Card.Title className='fw-bolder text-start'>
                          {project?.name}
                        </Card.Title>
                        <Card.Text className='text-start'>
                          {project?.shortDescription}
                        </Card.Text>
                      </div>
                      <div>
                        <Button
                          variant='primary fw-bold'
                          className=''
                          size='lg'
                          onClick={() =>
                            history.push(`/projectDetail/${project.id}`)
                          }
                        >
                          Details
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </motion.div>
            ))
          )}
        </Row>
      </Container>
      <Footer></Footer>
    </>
  );
};

export default AllProjects;
